module.exports = __webpack_public_path__ + "img/dep_fishandseafood@2x.3e4b9767.png";